import { NavLink as RouterNavLink, NavLinkProps } from 'react-router-dom';
import { forwardRef } from 'react';
import { cn } from '@xanectech/ui/lib';

interface NavLinkCompatProps extends Omit<NavLinkProps, 'className'> {
  className?: string;
  activeClassName?: string;
  pendingClassName?: string;
}

interface NavLinkClassNameParams {
  isActive: boolean;
  isPending: boolean;
}

const NavLink = forwardRef<HTMLAnchorElement, NavLinkCompatProps>(
  (
    {
      className,
      activeClassName,
      pendingClassName,
      to,
      ...props
    }: NavLinkCompatProps,
    ref: React.ForwardedRef<HTMLAnchorElement>,
  ) => {
    return (
      <RouterNavLink
        ref={ref}
        to={to}
        className={({ isActive, isPending }: NavLinkClassNameParams): string =>
          cn(
            className,
            isActive && activeClassName,
            isPending && pendingClassName,
          )
        }
        {...props}
      />
    );
  },
);

NavLink.displayName = 'NavLink';

export { NavLink, type NavLinkProps, type NavLinkClassNameParams };
